
import axios from 'axios';
import { backendUrl } from '../config/Config';
import { getFromLocalStorage } from './localStorage';

let headers = {};
let token = '';

const gettoken = async () => {
  var mytoken = getFromLocalStorage('token');
  if (mytoken) {
    token = mytoken;
    return token;
  }
  return;
};

const axiosInstance = axios.create({
  baseURL: backendUrl,
  headers,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    await gettoken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response);
    }),
  (error) => {
    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    if (error.response.status === 403) {
      // navigate(LOGOUT, {tokenExpired: true});
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  },
);

export default axiosInstance;

